module.exports = __webpack_public_path__ + "media/components/util/logos/vecteezy-logo--white-on-orange-73a803e49555c14b184939ca1a6108d6.jpg";